import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../components/ui/card';
import { Badge } from '../../components/ui/badge';
import { Clock, BookOpen, Lock, CheckCircle, ShoppingCart } from 'lucide-react';
import { CATEGORY_META } from './constants';

export const InhaberUpsellGrid = ({ allCourses = [], freeTrialModuleId, activatedPackageModules = [], onOpenCheckout }) => {
  const navigate = useNavigate();

  return (
    <Card className="bg-gray-900/50 border-gray-800">
      <CardHeader>
        <CardTitle className="text-white">Zukunftssicherung für deinen Betrieb</CardTitle>
        <CardDescription>Entdecke weitere Schulungen für dein Team</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {allCourses.slice(0, 9).map((mod) => {
            const cat = CATEGORY_META[mod.category] || CATEGORY_META.basis;
            const isFree = mod.id === freeTrialModuleId;
            const isUnlocked = activatedPackageModules.includes(mod.id) || isFree;

            return (
              <Card
                key={mod.id}
                className="bg-black/50 border-gray-800 hover:border-yellow-500/50 transition-all flex flex-col"
                data-testid={`upsell-card-${mod.id}`}
              >
                <CardContent className="pt-5 pb-5 flex flex-col h-full">
                  <div className="flex items-start gap-3 mb-3">
                    <div className="text-3xl shrink-0">{mod.icon || '📘'}</div>
                    <div className="flex-1 min-w-0">
                      <h3 className="text-white font-semibold leading-snug mb-1.5">{mod.title}</h3>
                      <div className="flex flex-wrap gap-1.5">
                        <Badge className={`${cat.color} border text-[10px] font-medium`}>{cat.label}</Badge>
                        {isFree && (
                          <Badge className="bg-green-500/20 text-green-400 border-green-500/30 border text-[10px]">
                            Gratis Testkurs
                          </Badge>
                        )}
                        {!isFree && !isUnlocked && (
                          <Badge className="bg-red-500/15 text-red-400 border-red-500/30 border text-[10px]">
                            <Lock className="w-2.5 h-2.5 mr-1" />Premium
                          </Badge>
                        )}
                        {!isFree && isUnlocked && (
                          <Badge className="bg-green-500/15 text-green-400 border-green-500/30 border text-[10px]">
                            <CheckCircle className="w-2.5 h-2.5 mr-1" />Aktiv
                          </Badge>
                        )}
                      </div>
                    </div>
                  </div>
                  <p className="text-sm text-gray-400 mb-4 line-clamp-3 flex-1">{mod.description}</p>
                  <div className="flex items-center gap-3 text-xs text-gray-500 mb-4">
                    <span className="flex items-center gap-1">
                      <Clock className="w-3 h-3" />{mod.duration_minutes || 45} Min
                    </span>
                    <span className="flex items-center gap-1">
                      <BookOpen className="w-3 h-3" />{mod.total_lessons || 6} Lektionen
                    </span>
                  </div>
                  <div className="flex gap-2 mt-auto">
                    <Button
                      size="sm"
                      variant="outline"
                      className="flex-1 border-gray-700 text-gray-300 hover:bg-gray-800"
                      onClick={() => navigate(`/kurs/${mod.id}`)}
                      data-testid={`details-btn-${mod.id}`}
                    >
                      Details
                    </Button>
                    {!isFree && !isUnlocked && mod.package_type && (
                      <Button
                        size="sm"
                        className="flex-1 bg-yellow-500 text-black hover:bg-yellow-400 font-medium"
                        onClick={() => onOpenCheckout(mod.package_type)}
                        data-testid={`buy-btn-${mod.id}`}
                      >
                        <ShoppingCart className="w-3.5 h-3.5 mr-1.5" /> Paket
                      </Button>
                    )}
                  </div>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
};
